import { render, staticRenderFns } from "./invoicingList.vue?vue&type=template&id=48e55bc2&scoped=true&"
import script from "./invoicingList.vue?vue&type=script&lang=js&"
export * from "./invoicingList.vue?vue&type=script&lang=js&"
import style0 from "./invoicingList.vue?vue&type=style&index=0&id=48e55bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e55bc2",
  null
  
)

export default component.exports